import Datagent from "datagent";
import Schema from "datagent/src/classes/Schema.class";
import { respondData, requestHandle } from "../utils";
import { defaults } from "datagent/src/utils";

import Fecha from "@/utils/type/Fecha"

const { format } = Datagent.Hooks

const publishSchema = new Schema({
  year: { type: String },
  rankDisplayTime: { type: Fecha },
  subRankDisplayTime: { type: Fecha },
});

const name = "release";
const Model = Datagent.Model({
  name,
  methods: {
    publish(params, opts) { // type: esg, csr
      const { origin } = defaults(opts);
      let { type, ...query } = params
      return this.remote(origin).post(`${this._url}/${type}`, query);
    },
    status(params, opts) { // type: esg, csr
      const { origin } = defaults(opts);
      return this.remote(origin).get(`${this._url}/isFinish`, params);
    },
  },
  hooks: {
    publish: { before: [format(publishSchema)], after: [respondData(), requestHandle()] },
    status: { after: [respondData(), requestHandle()] },
  }
});

Model.ModelName = name;
export default Model;
